export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto px-4 md:px-10 text-center">
        <div className="rounded-[24px] overflow-hidden mb-8 md:mb-10">
          <div
            className="w-full h-[280px] md:h-[360px] bg-cover bg-center"
            style={{
              backgroundImage: `url('https://readdy.ai/api/search-image?query=Lifestyle%20flat%20lay%20of%20fashion%20items%20sneakers%20hoodie%20bag%20and%20accessories%20arranged%20elegantly%20on%20light%20warm%20surface%20natural%20daylight%20editorial%20composition%20European%20aesthetic%20soft%20tones%20sophisticated%20modern%20product%20photography%20minimal%20clean%20harmonious%20layout&width=1200&height=600&seq=cta-flatlay-06&orientation=landscape')`,
            }}
          />
        </div>

        <div className="space-y-2 mb-8">
          <p className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 leading-tight">
            Entdecken Sie{' '}
            <span className="italic text-foreground-400 font-medium">OOPBUY Spreadsheet</span>
          </p>
          <p className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 leading-tight">
            auf{' '}
            <span className="italic text-foreground-400 font-medium">kaspreadsheet.com</span>
          </p>
          <p className="text-lg md:text-xl text-foreground-500 mt-2">
            Ihr direkter Zugang zu den besten Shopping-Angeboten
          </p>
        </div>

        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-foreground-950 text-white text-base font-semibold hover:bg-foreground-800 transition-all cursor-pointer whitespace-nowrap"
        >
          Jetzt bei kaspreadsheet.com shoppen
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </span>
        </a>
      </div>
    </section>
  );
}